import { Suspense, useMemo } from "react";
import { Canvas } from "@react-three/fiber";
import * as THREE from "three";
import City from "./City";
import DataStream from "./DataStream";
import SkillsConstellation from "./SkillsConstellation";
import CameraRig from "./CameraRig";
import PostFX from "./PostFX";
import { buildCumulativeFractions } from "./cameraPath";
import { SECTIONS } from "../data/content";
import { generateBuildings } from "../game/buildingLayout";

export default function Scene({ quality }) {
  const fractions = useMemo(
    () => buildCumulativeFractions(SECTIONS.map((s) => s.weight)),
    []
  );
  const buildings = useMemo(
    () => generateBuildings(quality.buildingDetail === "low" ? 16 : 34),
    [quality.buildingDetail]
  );

  return (
    <Canvas
      dpr={quality.dpr}
      gl={{ antialias: false, powerPreference: "high-performance" }}
      camera={{ fov: 55, near: 0.1, far: 300, position: [0, 22, 46] }}
      data-testid="three-canvas"
    >
      <color attach="background" args={["#050505"]} />
      <fog attach="fog" args={["#050512", 20, 130]} />
      <ambientLight intensity={0.35} />
      <pointLight position={[0, 20, 20]} intensity={40} color="#01FFFF" distance={80} />
      <pointLight position={[10, 8, -30]} intensity={30} color="#FF007F" distance={70} />
      <pointLight position={[-8, 6, -60]} intensity={25} color="#01FFFF" distance={60} />

      <Suspense fallback={null}>
        <City buildings={buildings} />
        <DataStream count={quality.particleCount} />
        <SkillsConstellation />
      </Suspense>

      <CameraRig fractions={fractions} />
      <PostFX bloomIntensity={quality.bloomIntensity} />
    </Canvas>
  );
}
